export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Me contactas',
      description: 'Escríbeme por WhatsApp o completa el formulario. Cuéntame qué necesitas y cuáles son tus dudas.',
      icon: 'ri-chat-smile-3-line'
    },
    {
      number: '02',
      title: 'Revisamos tu necesidad',
      description: 'Conversamos sobre tu situación actual, tus expectativas y las opciones disponibles para ti.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '03',
      title: 'Te acompaño en la orientación y gestión',
      description: 'Te guío en cada paso, resuelvo tus dudas y te apoyo hasta que tengas claridad total sobre tu decisión.',
      icon: 'ri-hand-heart-line'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-6">
            <span className="text-sm font-medium text-blue-600">Proceso</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Cómo funciona
          </h2>
          <p className="text-lg text-gray-700">
            Un proceso simple, claro y sin complicaciones
          </p>
        </div>

        {/* Steps */}
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-12 relative">
          {/* Connection Lines - Desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200 mx-32"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Card */}
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300 relative z-10">
                {/* Number Badge */}
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-3xl text-blue-600`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Arrow - Mobile */}
              {index < steps.length - 1 && (
                <div className="lg:hidden flex justify-center my-6">
                  <i className="ri-arrow-down-line text-3xl text-blue-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-12 text-white">
          <h3 className="text-2xl lg:text-3xl font-bold mb-4">
            ¿Listo para comenzar?
          </h3>
          <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
            Estoy aquí para ayudarte. Conversemos sobre tus necesidades de salud previsional.
          </p>
          <button
            onClick={() => window.open('https://wa.me/56944540956', '_blank')}
            className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-blue-600 rounded-full hover:bg-blue-50 transition-all hover:shadow-lg whitespace-nowrap font-medium"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>Iniciar conversación</span>
          </button>
        </div>
      </div>
    </section>
  );
}